/**
*
* PLUGIN: jquery.counter
* BY: Mattias Norell, Ninetech
* VERSION: 1.0 (based on jQuery 1.7.1)
* BROWSERS: Chrome 19, IE9, SafariMobile
* ABOUT: Display a counter
* HOW-TO: $(div).counter({Value:"123456789", Speed: 1000});
*
**/
(function ($) {
    $.fn.counter = function (options) {
        var defaults = {
            Value: "0",
            ClearBeforeRender: true,
            Speed: 1000,
            MinNumbers: 7,
            StartAt: "0",
            onAnimationStart: function () { },
            onAnimationEnd: function () { },

            template: "<ul><li>0</li><li>1</li><li>2</li><li>3</li><li>4</li><li>5</li><li>6</li><li>7</li><li>8</li><li>9</li></ul>"
        };

        var counter = $(this);

        var options = $.extend(defaults, options);

        var minNumbers = options.MinNumbers;
        var totalValue = options.Value;
        var startValue = options.StartAt;

        var totalValueArray = new Array();
        var totalValueString = totalValue.toString();
        var totalValueStringSplit = totalValueString.split('');

        var startValueArray = new Array();
        var startValueString = startValue.toString();
        var startValueStringSplit = startValueString.split('');

        var counterLineHeight = counter.css("line-height").split('px')[0];

        var animationsCompleted = 0;

        AddPadding(totalValueString, totalValueArray);
        AddPadding(startValueString, startValueArray);

        AddValues(startValueStringSplit, startValueArray);
        AddValues(totalValueStringSplit, totalValueArray);

        var totalValueLength = totalValueArray.length;

        if (options.ClearBeforeRender) counter.html("");

        if (!options.ClearBeforeRender && $(this).attr('data-rendered') != "true") {
            for (var i = 0; i < totalValueLength; i++) {
                counter.append(options.template);
            }

            $(this).attr('data-rendered', "true");
        }

        animationStart();

        for (var i = 0; i < totalValueLength; i++) {
            var dist = parseInt(totalValueArray[i]);
            var start = parseInt(startValueArray[i]);
            var distAnimation = counterLineHeight * dist;
            var startPosition = counterLineHeight * start;
            var ul;

            if (options.ClearBeforeRender) {
                counter.append(options.template);
                ul = counter.find("ul:last");
            } else {
                ul = counter.find("ul:eq(" + i + ")");
                ul.css('margin-top', 0 - startPosition)
            }

            ul.stop(true, false).animate({ "margin-top": 0 - distAnimation }, options.Speed, animationEnd);
        };

        function animationStart() {
            animationsCompleted = 0;
            options.onAnimationStart();
        };

        function animationEnd() {
            animationsCompleted++;
            
            if (totalValueLength == animationsCompleted) {
                options.onAnimationEnd();
            }
        };

        function AddPadding(str, arr) {
            var diff = minNumbers - str.length;
            if (diff > 0) {
                for (var i = 0; i < diff; i++) {
                    arr.push("0");
                };
            };
        };

        function AddValues(str, arr) {
            if (str.length > 0) {
                for (var i = 0; i < str.length; i++) {
                    arr.push(str[i]);
                };
            };
        }

        return false;
    };
})(jQuery);